import React from "react";
import classNames from "classnames";

type Props = {
  label: string;
  active?: boolean;
  onClick?: (event: any) => void;
  href?: string;
  target?: "_blank" | "_self" | "_parent" | "_top";
  disabled?: boolean;
};

export const SidebarSubOption: React.FC<Props> = ({
  label,
  active,
  onClick,
  href,
  target = "_self",
  disabled,
}) => {
  // if is a link, then it should be a <a> tag with href and target props
  const isLink = !!href;
  const Component = isLink ? "a" : "div";

  const handleClick = (event: any) => {
    if (disabled) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (onClick) {
      onClick(event);
    }
  };

  return (
    <Component
      className={classNames(
        "flex justify-start items-center px-5 py-3 cursor-pointer hover:bg-gradient-light rounded-sm",
        disabled && "opacity-50 cursor-not-allowed",
        active && "bg-gradient-light font-semibold",
      )}
      onClick={handleClick}
      href={href}
      target={target}
    >
      <span
        className={classNames("text-sm font-sans-serif text-dark-neutral-1 font-weight-normal")}
      >
        {label}
      </span>
    </Component>
  );
};
